import { ConfigsService, LocaleService } from '@sm360/widget-commons-core-services';
import { CookieService, ShiftDigitalService } from '@sm360/widget-commons-general';
import { Quote, ShowroomService } from '@sm360/widget-commons-vehicle';
import { INVENTORY, CATALOG } from 'deposit/constants/vehicleTypes.js';
import axios from 'axios';
import config from 'deposit/config/index.js';

class DepositAPIService {
    createDeposit(quote, stripeToken, contactInfo) {
        const trackedPageCookie = CookieService.getToken('primary-tracked-page');
        const adgearUidCookie = CookieService.getToken('aguid');

        const url = `${config.endpoint.widget}/widgets/deposits`;
        const axiosConfig = {
            headers: { locale: LocaleService.getLocale().replace('-', '_') },
        };
        const isInventoryVehicle = quote.vehicle.vehicleId > 0 || Number.parseInt(quote.vehicleId, 10) > 0;

        const deliveryCreationRequest = {
            deliveryCreation: {
                websiteId: ConfigsService.getWebsiteId(),
                vehicleInventoryId: quote.vehicle.vehicleId || quote.vehicleId,
                vehicleType: isInventoryVehicle ? INVENTORY : CATALOG,
                quote: quote.getShowroomQuote(),
                quoteId: quote.id,
                stripeToken,
                layoutWebsiteLocation: 'showroom.checkout.responsive',
                evaluationQuestionsValue: null,
                tradeIns: quote.tradeIns,
                contactInfo,
            },
            primaryTrackedPage: null,
            adgearUid: null,
        };

        if (trackedPageCookie) {
            try {
                deliveryCreationRequest.primaryTrackedPage = JSON.parse(trackedPageCookie.replace(/\\/g, ''));
            } catch (e) {
                throw e;
            }
        }

        if (adgearUidCookie) {
            deliveryCreationRequest.adgearUid = adgearUidCookie;
        }
        return axios.post(url, deliveryCreationRequest, axiosConfig).then((response) => {
            const depositQuote = Quote.QuoteService.resetQuoteDepositLead(quote, response.data);
            ShiftDigitalService.createFormEvent(response.data.leadId, 'Deposit | Showroom');
            return ShowroomService.saveQuote(depositQuote.getShowroomQuote(), false).then((showroomQuote) => {
                const newQuote = Quote.QuoteService.resetQuoteFromShowroomSave(depositQuote, showroomQuote);

                return Promise.resolve(newQuote);
            });
        });
    }
}

export default new DepositAPIService();



// WEBPACK FOOTER //
// ./src/services/DepositAPIService/DepositAPIService.js